import styled from "styled-components";
import theme from "../../../application/utils/Theme";

const Button = styled.button`
    background-color: ${theme.themeColor};
    color: white;
`;

export { Button }